module.exports = __webpack_public_path__ + "static/media/Oxygen-Bold.2b6ff5a3.ttf";